import { useState } from 'react';

import endpoints from '../../../../../../../api/endpoints';
import { useDialog } from '../../../../../../common/dialog/useDialog';
import { useHandleApiError } from '../../../../../../../api/useHandleApiError';
import { handleResponseError } from '../../../../../../../api/handleResponseError';
import { fetchWithTokenRefresh } from '../../../../../../../api/fetchWithTokenRefresh';

import { Operation } from './interfaces';
import { operationDetailsBusinessError } from '../businessErrors';

export const useShowOperationDetails = () => {
  const [selectedOperationDetails, setSelectedOperationDetails] = useState<Operation | undefined>();
  const [waitingForDialogOpening, setWaitingForDialogOpening] = useState<boolean>(false);
  const { isDialogOpen, handleOpenDialog, handleCloseDialog } = useDialog();
  const handleApiError = useHandleApiError();

  const handleOpenDetailsDialog = async (operationId: string) => {
    try {
      setWaitingForDialogOpening(true);
      const response = await fetchWithTokenRefresh(endpoints.customerValidationOperations(operationId));
      if (response.status !== 200) {
        await handleResponseError(response);
      }
      const operation = await response.json();

      setWaitingForDialogOpening(false);
      setSelectedOperationDetails(operation);
      handleOpenDialog();
    } catch (e) {
      setWaitingForDialogOpening(false);
      handleApiError({ message: e.message, errorMapper: operationDetailsBusinessError });
    }
  };

  const handleCloseDetailsDialog = () => {
    handleCloseDialog();
  };

  return {
    selectedOperationDetails,
    openDetailsDialog: isDialogOpen,
    waitingForDialogOpening,
    handleOpenDetailsDialog,
    handleCloseDetailsDialog
  };
};
